import React, { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import {
  BarChartOutlined,
  CheckSquareOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./task-management.css";

const TASK_MANAGEMENT_TABS = [
  {
    key: "caseSheet",
    label: "All Cases",
    icon: <FileTextOutlined />,
    moduleKey: "case-sheet",
  },
  {
    key: "myCaseSheet",
    label: "My Cases",
    icon: <UserOutlined />,
    moduleKey: "my-case-sheet",
  },
  {
    key: "mySubordinateCaseSheet",
    label: "Subordinate Cases",
    icon: <TeamOutlined />,
    moduleKey: "my-subordinate-case-sheet",
  },
  {
    key: "caseSheetApprovals",
    label: "Case Approvals",
    icon: <CheckSquareOutlined />,
    moduleKey: "case-sheet-approvals",
  },
  {
    key: "caseTargetIncentive",
    label: "Case Target",
    icon: <BarChartOutlined />,
    moduleKey: "case-target-incentive",
  },
];

const IndexTaskManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = useMemo(() => {
    const taskManagementIndex = location.pathname.toLowerCase().indexOf("/taskmanagement/");
    const activeSegment = taskManagementIndex >= 0
      ? location.pathname.slice(taskManagementIndex + "/taskManagement/".length).split("/")[0]
      : "";
    const matchedTab = TASK_MANAGEMENT_TABS.find((tab) => tab.key.toLowerCase() === activeSegment.toLowerCase());

    return matchedTab?.key || TASK_MANAGEMENT_TABS[0].key;
  }, [location.pathname]);

  const onChangeTab = (key) => {
    const selectedTab = TASK_MANAGEMENT_TABS.find((tab) => tab.key === key);

    if (selectedTab?.moduleKey) {
      localStorage.setItem("modulekey", selectedTab.moduleKey);
    }

    navigate(`/taskManagement/${key}`);
  };

  return (
    <section className="task-management-page">
      <div className="task-management-tabs-shell">
        <Tabs
          activeKey={ activeTab }
          onChange={ onChangeTab }
          className="task-management-tabs"
          items={ TASK_MANAGEMENT_TABS.map((tab) => ({
            key: tab.key,
            label: (
              <span className="task-management-tab-label">
                { tab.icon }
                <span>{ tab.label }</span>
              </span>
            ),
          })) }
        />
      </div>

      <div className="task-management-tab-content">
        <Outlet />
      </div>
    </section>
  );
};

export default IndexTaskManagement;
